
import {VENDOR_PROGRESSBAR_VIEW_REQUEST, VENDOR_PROGRESSBAR_VIEW_SUCCESS,VENDOR_PROGRESSBAR_VIEW_FAIL} from "../constants/AuthConstant";

const id =  localStorage.getItem("vendorid");

const axios = require("axios");
export const VendorProfileProgress = () => {
    return function (dispatch) {
      dispatch({
        type: VENDOR_PROGRESSBAR_VIEW_REQUEST,
        payload: true,
      });
  
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_profile_completion_percentage?vendorId=${id}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: VENDOR_PROGRESSBAR_VIEW_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: VENDOR_PROGRESSBAR_VIEW_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };